import { ILiveGateway } from 'src/core/player/interfaces/LiveGateway';
import Player from './Player';

class LivePlayer extends Player {
  constructor(protected gateway: ILiveGateway) {
    super(gateway);
  }

  get liveTracker() {
    return this.gateway.liveTracker;
  }

  get percentWatched() {
    if (!this.liveTracker) return 0;

    if (this.liveTracker.atLiveEdge) return 100;

    const currentTime = this.currentTime;

    return (currentTime * 100 - this.liveTracker.seekableStart) / this.liveTracker.liveWindow;
  }

  isCloseToLiveEdge() {
    const TIME_OFFSET = 7;

    const liveCurrentTime = this.liveTracker?.liveCurrentTime || 0;
    const currentTime = this.currentTime;

    if (!liveCurrentTime) return false;

    return currentTime + TIME_OFFSET >= liveCurrentTime;
  }

  setCurrentTimePercent(percent: number) {
    if (!this.liveTracker) return;

    let newTime: number;

    if (percent >= 99) {
      this.liveTracker.seekToLiveEdge();
      return;
    }

    const seekableStart = this.liveTracker.seekableStart;
    const seekableEnd = this.liveTracker.liveCurrentTime;

    newTime = seekableStart + (this.liveTracker.liveWindow / 100) * percent;

    if (newTime >= seekableEnd) {
      newTime = seekableEnd;
    } else if (newTime <= seekableStart) {
      newTime = seekableStart + 100;
    } else if (newTime === Infinity) {
      return;
    }

    this.setCurrentTime(newTime);
  }
}

export default LivePlayer;
